import { Spin } from 'antd';

const Loader = () => <Spin size="large" />

export default Loader;